import type { CommentReply, CollaborateUserRef, Thread } from "../types/collaborateThread";
import { normalizeMentionTags } from "./wrapMentionsInBody";

type ApiUserRef = Partial<CollaborateUserRef> & { id?: string };

function normalizeUserRef(user: ApiUserRef | null | undefined): CollaborateUserRef {
  return {
    id: String(user?.id ?? ""),
    name: String(user?.name ?? "").trim() || "Unknown",
    email: String(user?.email ?? "").trim(),
  };
}

function normalizeReply(reply: CommentReply): CommentReply {
  return {
    ...reply,
    body: normalizeMentionTags(reply.body),
    createdBy: normalizeUserRef(reply.createdBy),
    versionNumber: Number.isFinite(reply.versionNumber)
      ? reply.versionNumber
      : 0,
    versionTagged: reply.versionTagged !== false,
  };
}

/** Map API thread payloads into the shape expected by the collaborate UI. */
export function normalizeCollaborateThread(raw: Thread): Thread {
  const assignee = raw.assignee ? normalizeUserRef(raw.assignee) : null;
  const status = raw.status ?? "pending";
  const requireApproval =
    raw.requireApproval === true || Boolean(assignee && status === "pending");

  return {
    ...raw,
    body: normalizeMentionTags(raw.body ?? ""),
    status,
    requireApproval,
    assignee,
    createdBy: normalizeUserRef(raw.createdBy),
    versionNumber: Number.isFinite(raw.versionNumber)
      ? raw.versionNumber
      : 0,
    versionTagged: raw.versionTagged !== false,
    replies: (raw.replies ?? []).map(normalizeReply),
  };
}
